import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid default-dashboard" }
const _hoisted_2 = { class: "row widget-grid" }
const _hoisted_3 = { class: "col-xl-5 col-md-6 proorder-xl-3 proorder-md-1" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexHome',
  setup(__props) {


const  AtmosOverview =  defineAsyncComponent(() => import('@/components/theme/dashboards/home/AtmosOverview.vue'))
const  BaraniOverview =  defineAsyncComponent(() => import('@/components/theme/dashboards/home/BaraniOverview.vue'))
const  PawsOverview =  defineAsyncComponent(() => import('@/components/theme/dashboards/home/PawsOverview.vue'))
const  PawsOverview2 = defineAsyncComponent(() => import('@/components/theme/dashboards/home/PawsOverview2.vue'))
const  AWSstatus =  defineAsyncComponent(() => import('@/components/theme/dashboards/home/AWSstatus.vue'))
const  WelcomeView = defineAsyncComponent(() => import("@/components/theme/dashboards/home/WelcomeView.vue"))
const  ActiveMembers = defineAsyncComponent(() => import("@/components/theme/dashboards/home/ActiveMembers.vue"))
const  HighestRecord = defineAsyncComponent(() => import("@/components/theme/dashboards/home/HighestRecord.vue"))
const  ScheduledUpdates = defineAsyncComponent(() => import("@/components/theme/dashboards/home/ScheduledUpdates.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(WelcomeView)),
        _createVNode(_unref(AWSstatus))
      ]),
      _createVNode(_unref(ActiveMembers)),
      _createVNode(_unref(AtmosOverview)),
      _createVNode(_unref(BaraniOverview)),
      _createVNode(_unref(PawsOverview)),
      _createVNode(_unref(PawsOverview2)),
      _createVNode(_unref(HighestRecord)),
      _createVNode(_unref(ScheduledUpdates))
    ])
  ]))
}
}

})